var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alpheios-morph-data__principal_parts" },
    [
      _vm._l(_vm.allLemmas, function (lemma, lemmaIndex) {
        return _c(
          "div",
          {
            key: lemmaIndex,
            staticClass: "alpheios-morph-data__principal_parts",
          },
          [
            _c("principal-parts", {
              attrs: {
                lemma: lemma,
                lemmaindex: lemmaIndex,
                lexemeslength: _vm.lexemeslength,
                lexemeindex: _vm.lexemeindex,
                disambiguated: _vm.lexeme.disambiguated,
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.hasMorphData
        ? _c(
            "div",
            { staticClass: "alpheios-morph-data__morphdata" },
            [
              _c(
                "span",
                { staticClass: "alpheios-morph-data__pofs" },
                _vm._l(_vm.featuresList.pofs, function (feat, featIndex) {
                  return _c("inflectionattribute", {
                    key: featIndex,
                    attrs: {
                      data: _vm.lexeme.lemma.features,
                      type: _vm.types[feat],
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.featuresList.others, function (feat, featIndex) {
                return _c("inflectionattribute", {
                  key: featIndex,
                  attrs: {
                    data: _vm.lexeme.lemma.features,
                    type: _vm.types[feat.name],
                    decorators: [feat.decorator],
                  },
                })
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }